import React from 'react'

import { Query } from 'types/graphql/schema'
import { useQuery } from 'utils/graphql'


type currentUser = Query['currentUser']

export const userContext = React.createContext({} as {
  data?: currentUser
  failure?: unknown
  isFetching: boolean
  refetch: CallableFunction
  spinner: JSX.Element | null
})

export function useUserContext() {
  const user = useQuery(
    {
      currentUser: {
        __scalar: 1,
        calculationTemplates: { __scalar: 1 },
        defaultCalculationTemplate: {
          __scalar: 1,
          calculationInput: {
            __scalar: 1,
            currency: { __scalar: 1 },
            product: { id: 1 },
            region: { id: 1 },
          },
        },
      }
    },
    'currentUser'
  )
  const refetch = user.refetch
  React.useEffect(() => refetch(), [refetch])
  return user
}
